import { useMemo } from 'react';
import { Settings, Info } from 'lucide-react';
import { useCurrentStateAndParams } from '@uirouter/react';

import { PageHeader } from '@@/PageHeader';
import { Tab, WidgetTabs, useCurrentTabIndex } from '@@/Widget/WidgetTabs';
import { WidgetBody } from '@@/Widget/WidgetBody';
import { Widget } from '@@/Widget/Widget';

import { usePolicy } from '../queries/usePolicy';

import { PolicyDetailsTab } from './PolicyDetailsTab';
import { ConfigTab } from './ConfigTab';
import { AttachmentsDataTable } from './AttachmentsDataTable/AttachmentsDataTable';

export function PolicyDetailView() {
  const { params } = useCurrentStateAndParams();
  const policyId = Number(params.id);
  const policyQuery = usePolicy(policyId);
  const policy = policyQuery.data;
  const policyName = policy?.Name ?? 'Policy';

  const tabs: Tab[] = useMemo(
    () => [
      {
        name: 'Policy Details',
        icon: Info,
        widget: (
          <div className="row">
            <div className="col-sm-12">
              <Widget>
                <WidgetBody>
                  <PolicyDetailsTab policyId={policyId} />
                </WidgetBody>
              </Widget>
            </div>
          </div>
        ),
        selectedTabParam: 'details',
      },
      {
        name: 'Config',
        icon: Settings,
        widget: policy ? <ConfigTab policy={policy} /> : null,
        selectedTabParam: 'config',
      },
    ],
    [policyId, policy]
  );

  const currentTabIndex = useCurrentTabIndex(tabs);

  return (
    <>
      <PageHeader
        title={policyName}
        breadcrumbs={[
          { label: 'Policies', link: 'portainer.policies' },
          policyName,
        ]}
        reload
      />
      <WidgetTabs tabs={tabs} currentTabIndex={currentTabIndex} />
      {tabs[currentTabIndex].widget}
      <AttachmentsDataTable policyId={policyId} />
    </>
  );
}
